import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class delegationService {
  async create(obj) {
    try {
      const result = await client.post('delegation/create', obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`delegation/update/${id}`, obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
  
  async fetch(params) {
    try {      
      const result = await client.get('delegation/index', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`delegation/view/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`delegation/delete/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new delegationService();
